import React from "react";

const FloatingButtons = () => {
  return (
    <>
      <style>{`
        /* Icon lắc trái phải */
        @keyframes shake-horizontal {
          0% { transform: translateX(0); }
          25% { transform: translateX(-2px); }
          50% { transform: translateX(2px); }
          75% { transform: translateX(-2px); }
          100% { transform: translateX(0); }
        }

        /* Vòng ngoài cùng tỏa đều đặn */
        @keyframes pulse-ring {
          0% {
            transform: scale(1);
            opacity: 0.6;
          }
          100% {
            transform: scale(1.8);
            opacity: 0;
          }
        }

        .icon-shake {
          animation: shake-horizontal 1s infinite ease-in-out;
        }

        .outer-ring {
          position: absolute;
          width: 100%;
          height: 100%;
          border-radius: 9999px;
          background-color: currentColor;
          opacity: 0.4;
          animation: pulse-ring 2s infinite;
        }
      `}</style>

      <div className="fixed right-4 bottom-20 sm:bottom-1 z-50 flex flex-col space-y-1">
        {/* Location Button */}
        <div className="relative w-16 h-16 flex items-center justify-center text-red-500">
          <span className="outer-ring"></span>
          <button
            className="bg-red-500 rounded-full w-12 h-12 flex items-center justify-center"
            onClick={() =>
              window.open(
                "https://www.google.com/maps/place/Kh%C3%A1ch+s%E1%BA%A1n+%C4%90%E1%BA%BF+V%C6%B0%C6%A1ng/@10.4565167,105.6487803,18z/data=!3m1!4b1!4m9!3m8!1s0x310a6456d8b0f71b:0x7bdeef1ea238540d!5m2!4m1!1i2!8m2!3d10.4565167!4d105.6500678!16s%2Fg%2F11b67jxdx1!5m1!1e4?hl=vi&entry=ttu&g_ep=EgoyMDI1MDQxNC4xIKXMDSoASAFQAw%3D%3D",
                "_blank",
                "noopener,noreferrer"
              )
            }
          >
            <svg
              className="w-6 h-6 text-white icon-shake"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z"
              />
            </svg>
          </button>
        </div>

        {/* Zalo Button */}
        <div className="relative w-16 h-16 flex items-center justify-center text-blue-400">
          <span className="outer-ring"></span>
          <a
            href="https://zalo.me/0586706868" 
            target="_blank"
            rel="noopener noreferrer"
            className="bg-blue-500 rounded-full w-12 h-12 flex items-center justify-center"
          >
            <svg
              className="w-6 h-6 text-white icon-shake"
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="100"
              height="100"
              viewBox="0 0 48 48"
            >
              <path
                fill="#2962ff"
                d="M15,36V6.827l-1.211-0.811C8.64,8.083,5,13.112,5,19v10c0,7.732,6.268,14,14,14h10	c4.722,0,8.883-2.348,11.417-5.931V36H15z"
              ></path>
              <path
                fill="#eee"
                d="M29,5H19c-1.845,0-3.601,0.366-5.214,1.014C10.453,9.25,8,14.528,8,19	c0,6.771,0.936,10.735,3.712,14.607c0.216,0.301,0.357,0.653,0.376,1.022c0.043,0.835-0.129,2.365-1.634,3.742	c-0.162,0.148-0.059,0.419,0.16,0.428c0.942,0.041,2.843-0.014,4.797-0.877c0.557-0.246,1.191-0.203,1.729,0.083	C20.453,39.764,24.333,40,28,40c4.676,0,9.339-1.04,12.417-2.916C42.038,34.799,43,32.014,43,29V19C43,11.268,36.732,5,29,5z"
              ></path>
              <path
                fill="#2962ff"
                d="M36.75,27C34.683,27,33,25.317,33,23.25s1.683-3.75,3.75-3.75s3.75,1.683,3.75,3.75	S38.817,27,36.75,27z M36.75,21c-1.24,0-2.25,1.01-2.25,2.25s1.01,2.25,2.25,2.25S39,24.49,39,23.25S37.99,21,36.75,21z"
              ></path>
              <path
                fill="#2962ff"
                d="M31.5,27h-1c-0.276,0-0.5-0.224-0.5-0.5V18h1.5V27z"
              ></path>
              <path
                fill="#2962ff"
                d="M27,19.75v0.519c-0.629-0.476-1.403-0.769-2.25-0.769c-2.067,0-3.75,1.683-3.75,3.75	S22.683,27,24.75,27c0.847,0,1.621-0.293,2.25-0.769V26.5c0,0.276,0.224,0.5,0.5,0.5h1v-7.25H27z M24.75,25.5	c-1.24,0-2.25-1.01-2.25-2.25S23.51,21,24.75,21S27,22.01,27,23.25S25.99,25.5,24.75,25.5z"
              ></path>
              <path
                fill="#2962ff"
                d="M21.25,18h-8v1.5h5.321L13,26h0.026c-0.163,0.211-0.276,0.463-0.276,0.75V27h7.5	c0.276,0,0.5-0.224,0.5-0.5v-1h-5.321L21,19h-0.026c0.163-0.211,0.276-0.463,0.276-0.75V18z"
              ></path>
            </svg>
          </a>
        </div>

        {/* Phone Button */}
        <div className="relative w-16 h-16 flex items-center justify-center text-red-500">
          <span className="outer-ring"></span>
          <a
            href="tel:0586706868"
            className="bg-red-500 rounded-full w-12 h-12 flex items-center justify-center"
          >
            <button>
              <svg
                className="w-6 h-6 text-white icon-shake"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 32 32"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  d="M13.6,8.5L9.5,4.3C9,3.9,8.3,3.9,7.8,4.3L4.7,7.5C4,8.1,3.8,9.1,4.1,9.9c0.8,2.3,2.9,6.9,7,11s8.7,6.1,11,7 c0.9,0.3,1.8,0.1,2.5-0.5l3.1-3.1c0.5-0.5,0.5-1.2,0-1.7l-4.1-4.1c-0.5-0.5-1.2-0.5-1.7,0l-2.5,2.5c0,0-2.8-1.2-5-3.3s-3.3-5-3.3-5 l2.5-2.5C14.1,9.7,14.1,8.9,13.6,8.5z"
                />
              </svg>
            </button>
          </a>
        </div>
      </div>
    </>
  );
};

export default FloatingButtons;
